import { create } from 'zustand'

export const useModalsStore = create((set, get) => ({
    modals: [],
    setModals: (value) => set({modals: value}),
    openModal: (newModal) => set({modals: [...get().modals, newModal]}),
    closeModal: (index) => {
        const newModals = get().modals.slice(0)
        newModals.splice(index, 1)
        set({modals: newModals})
    },
    closeAllModals: () => set({modals: []}),
    findModalByName: (name) => get().modals.find((modal) => modal.element.name === name),
    hasModalOpen: () => Boolean(get().modals.length),
    closeModalById: (modalId) => {
        let newModals = get().modals.slice(0)
        newModals = newModals.filter((modal) => modal.id !== modalId)
        set({modals: newModals})
    },
    closeTopModal: () => {
        let newModals = get().modals.slice(0)
        newModals.pop()
        set({modals: newModals})
    },
    findModalById: (modalId) => get().modals.find((modal) => modal.id === modalId),

    updateModalById: (modalId, newModal) => {
        const newModals = get().modals.slice(0)
        const newUpdatedModal = newModal

        for (let i = 0; i < newModals.length; i++) {
            const modal = newModals[i]
            if (modal.id=== modalId) {
                const oldModalProps = {...modal.props}
                const newModalProps = newModal.props
                newUpdatedModal.props = {...oldModalProps, ...newModalProps}
                newModals[i] = newUpdatedModal
            }
        }
        set({modals: newModals})
    }
}))